import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "md:w-1/2 flex justify-center items-center" }
const _hoisted_3 = { class: "max-w-2xl p-6 ml-auto" }
const _hoisted_4 = { class: "flex justify-center items-center md:ml-auto md:w-1/2 pl-6" }
const _hoisted_5 = ["src", "alt"]

import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import { PageBlock } from "@/views/blocks/PageBlock.interface";
import { FeaturesBaseProps } from "./features.interfaces";
import { computed } from "vue";
import EditableElement from "@/views/page/EditableElement.vue";
import TagComponent from "@/views/blocks/features/shared/tag/TagComponent.vue";
import TitleComponent from "@/views/blocks/features/shared/title/TitleComponent.vue";
import DescriptionComponent from "@/views/blocks/features/shared/description/DescriptionComponent.vue";
import FeaturesComponent from "@/views/blocks/features/shared/features/FeaturesComponent.vue";
import FeatureComponent from "@/views/blocks/features/shared/features/FeatureComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'WithProductScreenShot',
  props: {
    block: {},
    pageColors: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.block.webId,
    style: _normalizeStyle({ backgroundColor: styleValues.value.background }),
    class: "md:flex py-24 sm:py-32"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!dataValues.value.tag.isHidden)
          ? (_openBlock(), _createBlock(EditableElement, {
              key: 0,
              blockId: _ctx.block.id,
              "field-name": "tag"
            }, {
              default: _withCtx(() => [
                _createVNode(TagComponent, {
                  text: dataValues.value.tag.data.text,
                  textColor: styleValues.value.brand
                }, null, 8, ["text", "textColor"])
              ]),
              _: 1
            }, 8, ["blockId"]))
          : _createCommentVNode("", true),
        (!dataValues.value.title.isHidden)
          ? (_openBlock(), _createBlock(EditableElement, {
              key: 1,
              blockId: _ctx.block.id,
              "field-name": "title"
            }, {
              default: _withCtx(() => [
                _createVNode(TitleComponent, {
                  text: dataValues.value.title.data.text,
                  textColor: styleValues.value.text,
                  tag: dataValues.value.title.data.tag
                }, null, 8, ["text", "textColor", "tag"])
              ]),
              _: 1
            }, 8, ["blockId"]))
          : _createCommentVNode("", true),
        (!dataValues.value.description.isHidden)
          ? (_openBlock(), _createBlock(EditableElement, {
              key: 2,
              blockId: _ctx.block.id,
              "field-name": "description"
            }, {
              default: _withCtx(() => [
                _createVNode(DescriptionComponent, {
                  text: dataValues.value.description.data.text,
                  textColor: styleValues.value.text
                }, null, 8, ["text", "textColor"])
              ]),
              _: 1
            }, 8, ["blockId"]))
          : _createCommentVNode("", true),
        _createVNode(FeaturesComponent, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.features.data.items, (feature) => {
              return (_openBlock(), _createBlock(EditableElement, {
                key: feature.id,
                blockId: _ctx.block.id,
                "field-name": `features_${feature.id}`,
                hideable: false
              }, {
                default: _withCtx(() => [
                  _createVNode(FeatureComponent, {
                    title: feature.title,
                    description: feature.description,
                    "text-color": styleValues.value.text,
                    "icon-src": feature.iconSrc
                  }, null, 8, ["title", "description", "text-color", "icon-src"])
                ]),
                _: 2
              }, 1032, ["blockId", "field-name"]))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!dataValues.value.image.isHidden)
        ? (_openBlock(), _createBlock(EditableElement, {
            key: 0,
            blockId: _ctx.block.id,
            "field-name": "image"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: dataValues.value.image.data.src,
                alt: dataValues.value.image.data.alt,
                class: "md:ml-auto object-cover"
              }, null, 8, _hoisted_5)
            ]),
            _: 1
          }, 8, ["blockId"]))
        : _createCommentVNode("", true)
    ])
  ], 12, _hoisted_1))
}
}

})